import { TBookingCart, TBookingContext, TBookingData } from '@providers/booking/types'

export const hasGroomBeenChosen = (cart: TBookingCart) => {
  return (cart.groups ?? []).some((group) => group.grooms.some((groom) => groom.length > 0))
}

export const getResourcesInAGroup = (state: TBookingContext) => {
  const { grooms } = (state.data as TBookingData) ?? {}
  if (grooms?.length) {
    const resourcesInAGroup = grooms.reduce((acc: string[], groom) => {
      const { serviceOffers } = groom.offer!
      if (serviceOffers?.length) {
        const serviceResources = serviceOffers
          .flatMap((serviceOffer) => serviceOffer!.service!.serviceResources)
          .filter((serviceResource) => serviceResource!.group !== null)

        if (serviceResources?.length) {
          acc.push(...serviceResources.map((sr) => sr.resourceId!))
        }
        return acc
      }
    }, [] as string[])

    return Array.from(new Set(resourcesInAGroup as string[]))
  }

  return []
}
